import { render, staticRenderFns } from "./login-password.vue?vue&type=template&id=1d0675f0&"
import script from "./login-password.vue?vue&type=script&lang=js&"
export * from "./login-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports